import React, { useState } from "react";
import { Row, Col, Dropdown, Breadcrumb } from "react-bootstrap";
import { FiFileText, FiCalendar } from "react-icons/fi";
// import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import LeadsStatsCards from "../../components/Dashboard/leads-dashboard/LeadsStatsCards";
import {
  LeadsPipelineStagesCard,
  PipelineStages,
} from "../../components/Dashboard/leads-dashboard/LeadsPipelineStagesCard";
import { NewLeadsCard } from "../../components/Dashboard/leads-dashboard/NewLeadsCard";
import LeadsByCompanies from "../../components/Dashboard/leads-dashboard/LeadsByCompanies";
import LeadsBySource from "../../components/Dashboard/leads-dashboard/LeadsBySource";
import LostLeadsCard from "../../components/Dashboard/leads-dashboard/LostLeadsCard";
import RecentFollowUp from "../../components/Dashboard/deals-dashboard/DealsFollupsCard";
import RecentActivitiesCard from "../../components/Dashboard/deals-dashboard/RecentActivitiesCard";
import LeadsNotification from "../../components/Dashboard/leads-dashboard/LeadsNotification";
import TopCountriesCard from "../../components/Dashboard/leads-dashboard/TopCountriesCard";
import RecentLeadsCard from "../../components/Dashboard/leads-dashboard/RecentLeadsCard";
import CompanyDetails from "./CompanyDetails";
import { RiHome6Line } from "react-icons/ri";

const LeadsDashboardPage = () => {
  const [rangeLabel, setRangeLabel] = useState("Last 7 Days");
  const [dateRange, setDateRange] = useState("03/11/2026 - 03/17/2026");
  const [filter, setFilter] = useState("This Week");
  const [selectedCompany, setSelectedCompany] = useState(null);
  // DATE HANDLER
  const handleRangeChange = (type) => {
    const today = new Date();

    const format = (d) =>
      `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
        d.getDate(),
      ).padStart(2, "0")}/${d.getFullYear()}`;

    let start, end;

    switch (type) {
      case "Today":
        start = end = new Date();
        break;

      case "Yesterday":
        start = end = new Date();
        start.setDate(start.getDate() - 1);
        end = new Date(start);
        break;

      case "Last 7 Days":
        end = new Date();
        start = new Date();
        start.setDate(end.getDate() - 6);
        break;

      case "Last 30 Days":
        end = new Date();
        start = new Date();
        start.setDate(end.getDate() - 29);
        break;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        end = new Date(today.getFullYear(), 11, 31);
        break;

      default:
        return;
    }

    setRangeLabel(type);
    setDateRange(`${format(start)} - ${format(end)}`);
  };

  return (
    <div
      style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }}
      className="page-breadcrumb mb-3"
    >
      <Row className="align-items-center justify-content-between">
        {/* LEFT SIDE (UNCHANGED) */}
        <Col md={4} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Leads Dashboard
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="text-dark"
                  style={{ fontSize: "1.2rem" }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Dashboard
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Leads Dashboard</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        {/* RIGHT SIDE (UPDATED DESIGN) */}
        <Col md={6}>
          <div className="toolbar">
            {/* EXPORT */}
            <Dropdown>
              <Dropdown.Toggle
                style={{ fontWeight: "500" }}
                className="toolbar-btn"
              >
                <FiFileText className="icon" />
                Export
                <IoIosArrowDown />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="dropdown-box">
                <Dropdown.Item>Export as PDF</Dropdown.Item>
                <Dropdown.Item>Export as Excel</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* DATE RANGE */}
            <Dropdown>
              <Dropdown.Toggle
                style={{ fontWeight: "500" }}
                className="toolbar-btn"
              >
                <FiCalendar className="icon" />
                {dateRange}
                <IoIosArrowDown />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="date-dropdown">
                {[
                  "Today",
                  "Yesterday",
                  "Last 7 Days",
                  "Last 30 Days",
                  "This Year",
                ].map((item) => (
                  <Dropdown.Item
                    key={item}
                    onClick={() => handleRangeChange(item)}
                    className={rangeLabel === item ? "active-item" : ""}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
      </Row>

      <LeadsStatsCards />
      <Row>
        <Col xl={8}>
          <LeadsPipelineStagesCard />
        </Col>

        <Col xl={4}>
          <NewLeadsCard />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col lg={4}>
          <LostLeadsCard />
        </Col>

        <Col lg={4}>
          <LeadsByCompanies />
        </Col>

        <Col lg={4}>
          <LeadsBySource />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col lg={4}>
          <RecentFollowUp />
        </Col>

        <Col lg={4}>
          <RecentActivitiesCard />
        </Col>

        <Col lg={4}>
          <LeadsNotification />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col lg={5}>
          <TopCountriesCard />
        </Col>

        <Col lg={7} className="mt-3 mt-lg-0">
          <RecentLeadsCard onSelect={setSelectedCompany} />
        </Col>
      </Row>

      {/* CLEAN CSS */}
      <style>{`
        .toolbar {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }
          .dropdown-toggle::after {
  display: none !important;
}
        .toolbar-btn {
          background: #f3f4f6 !important;
          border: 1px solid #e5e7eb !important;
          border-radius: 10px !important;
          padding: 8px 14px !important;
          font-size: 14px !important;
          display: flex;
          align-items: center;
          gap: 6px;
          color: #111827;
        }

        .toolbar-btn:hover {
          background: #ffe7d6 !important;
          color: #f97316 !important;
          border-color: #f97316 !important;
        }

        .icon {
          font-size: 16px;
        }

        .dropdown-box {
          border-radius: 10px;
          padding: 6px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.08);
        }

        .dropdown-box .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
        }

        .dropdown-box .dropdown-item:hover {
          background: #fff3ed;
          color: #f97316;
        }

        .date-dropdown {
          padding: 10px;
          border-radius: 12px;
          width: 220px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }

        .date-dropdown .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
          padding: 8px 10px;
        }

        .date-dropdown .dropdown-item:hover {
          background: #fff3ed;
          color: #f97316;
        }

        .active-item {
          background: #f97316 !important;
          color: #fff !important;
        }
      `}</style>
    </div>
  );
};
export default LeadsDashboardPage;
